import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
/**
 * @internal
 */
var Placeholder = function (_a) {
    var message = _a.message;
    return (React.createElement(Flex, { vAlign: "center", hAlign: "center", styles: { height: "100%", border: "1px dashed rgb(179, 176, 173)" } },
        React.createElement(Text, { size: "large", weight: "semibold" }, message)));
};
export { Placeholder };
//# sourceMappingURL=Placeholder.js.map